import { mount } from '../boot.js';
import { Calendar } from './Calendar.js';

mount(Calendar);
